import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Box,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';
import { downloadFileFromUrl } from '../../../../common/logic/FileDownloader';
import { GeneralButton } from '../../../../common/ui/GeneralButton';

type Props = {
  open: boolean;
  onClose: () => void;
  name: string;
  filename: string;
  fileUrl: string | null;
};

const FileDialog = ({ open, onClose, name, filename, fileUrl }: Props) => {
  const { t } = useTranslation();

  const isPdf = fileUrl?.endsWith('.pdf');

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{name}</DialogTitle>
      <DialogContent
        dividers
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          padding: 3,
        }}
      >
        {fileUrl && (
          <Stack spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant="body2">
              {t('serviceModulesPage.folderServicePage.existingFile')} {filename}
            </Typography>
            {isPdf ? (
              <Button
                variant="text"
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('serviceModulesPage.folderServicePage.openPdf')}
              </Button>
            ) : (
              <Box
                sx={{
                  maxWidth: 500,
                  maxHeight: 300,
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#f8f8f8',
                  borderRadius: 1,
                }}
              >
                <img
                  src={fileUrl}
                  alt="Uploaded"
                  style={{
                    width: 'auto',
                    height: 'auto',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            )}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        {fileUrl && (
          <GeneralButton
            appVariant="primary"
            startIcon={<DownloadIcon />}
            onClick={async () => {
              try {
                await downloadFileFromUrl(fileUrl, filename);
              } catch (error) {
                console.error("Download error", error);
              }
            }}
          >
            {t("buttons.download")}
          </GeneralButton>
        )}

        <GeneralButton
          appVariant="secondary"
          onClick={onClose}
        >
          {t("buttons.close")}
        </GeneralButton>
      </DialogActions>
    </Dialog>
  );
};

export default FileDialog
